import { render, staticRenderFns } from "./taiwanTravelPolicy.vue?vue&type=template&id=071b17d2&scoped=true&"
import script from "./taiwanTravelPolicy.vue?vue&type=script&lang=js&"
export * from "./taiwanTravelPolicy.vue?vue&type=script&lang=js&"
import style0 from "./taiwanTravelPolicy.vue?vue&type=style&index=0&id=071b17d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b17d2",
  null
  
)

export default component.exports